import React from 'react';
import PropTypes from 'prop-types';

const NoCaseSelectedBox = () => {
  return (
    <div className="calc-nocase-box calc-div-inline calc-div-inline-space">
        <span>Ekkert mál valið, vinsamlegast opnið mál til að reikna.</span>
    </div>
  );
};

NoCaseSelectedBox.propTypes = {
  data: PropTypes.number,
};

export default NoCaseSelectedBox;




// WEBPACK FOOTER //
// ./src/pages/Calculation/Boxes/NoCaseSelectedBox.js